module.exports = __webpack_public_path__ + "static/media/digital-marketing-institute.0ba62977.jpg";